import { track } from "jiffy-analytics";
import { api } from "jiffy-api";
import { loadVisibleCompositionEstimates } from "components/jiffy/products/product-composition-estimates";
import "components/jiffy/bogo-recommended-blanks/bogo-recommended-blanks";

const PRODUCT_RECOMMENDATION_CLICK_EVENT = "product_recommendation_click";

const getElements = (() => {
  let $cachedContainer = null;

  return {
    get $container() {
      $cachedContainer ??= document.querySelector(".js-bogo-blanks-recommendations-list");
      return $cachedContainer;
    },

    get $skeleton() {
      return this.$container?.querySelector(".js-bogo-blanks-recommendations-skeleton");
    },

    $getItem({ target: $target }) {
      return $target.closest(".js-bogo-recommended-blanks-item");
    },

    $getProductId($item) {
      return $item?.querySelector("[data-product-id]");
    }
  };
})();

const initProductClickTracking = () => {
  getElements.$container?.addEventListener("click", event => {
    const $item = getElements.$getItem(event);
    if (!$item) return;

    const productId = getElements.$getProductId($item)?.dataset?.productId;
    if (productId) {
      track(PRODUCT_RECOMMENDATION_CLICK_EVENT, { product_id: productId });
    }
  });
};

let initialized = false;

const fetchAndRenderProducts = async () => {
  if (initialized) return;
  initialized = true;

  const { $container, $skeleton } = getElements;
  if (!$container) return;

  try {
    const response = await api.dtf.bogoRecommendedBlanks();

    if (response.html?.trim()) {
      $container.innerHTML = response.html;
      // Initialize delivery dates for the injected product cards
      loadVisibleCompositionEstimates();
      initProductClickTracking();
    } else {
      $skeleton?.classList.add("hidden");
    }
  } catch {
    $skeleton?.classList.add("hidden");
  }
};

export default fetchAndRenderProducts;
